import BaseHttpService from "../baseService";

class StockServiceProvider extends BaseHttpService {
	constructor() {
		super("asset");
	}

	/**
	 * stock info
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public AssetInfo(): Promise<HttpService.AssetInfo[]> {
		return this.getResource().post("info");
	}

	/**
	 * Search api call
	 * @param {object} filters
	 * @param {object} config
	 * @return {Promise}
	 */
	search(filters?: SearchServices.SearchDto, config: object = {}): SearchServices.BaseResponse<HttpService.AssetInfo> {
		return super.search(filters, config);
	}
}

const StockService = new StockServiceProvider();

export default StockService;
